import { useCustomEvents } from "mkm-gtm";

const { pushCustomEvent, CustomEvents } = useCustomEvents();

export const getPageType = () => {
  const route = useRoute();
  const path = route.path;

  const pageMap = {
    "/category": "category page",
    "/search": "search results page",
    "/branches": "branch page",
    "/cart": "cart page",
    "/account": "account page",
    "/": "homepage",
  };

  const matchedEntry = Object.entries(pageMap).find(([prefix]) => path === prefix || path.startsWith(prefix + "/"));

  return matchedEntry?.[1] ?? "unknown";
};

export const fireSearchEngagement = (searchTerm: string) => {
  const { user } = useUser();
  const { selectedBranch } = useBranches();
  const bloomreachCookie = useCookie("_br_uid_2");
  const userCategory = user.value?.account.business_type.split("|");
  const isTrade = userCategory?.[0] === "NTrade" ? "NON-TRADE" : userCategory?.[0] === "Trade" ? "TRADE" : null;

  pushCustomEvent(CustomEvents.SEARCH_ENGAGEMENT, {
    acct_id: bloomreachCookie.value || "noBrCookie",
    search_term: searchTerm,
    selected_branch: selectedBranch.value?.name ?? null,
    logged_in: !!user.value,
    ...(!!user.value && {
      user_id: user.value?.id ?? null,
      customer_category_1: user ? isTrade : "Guest",
      customer_category_2: userCategory?.[1] ?? null,
      customer_category_3: userCategory?.[2] ?? null,
      account_type: user.value?.account.type ?? null,
      account_owning_branch: user.value?.account.branch_id ?? null,
    }),
    page_type: getPageType(),
  } as any);
};
